import { EnvironmentProviders, inject, Provider } from '@angular/core';
import { provideSearchModule } from '@softapps/core';
import { ConnectionHttpService } from '@softline/core';
import { FieldOkService } from '@softline/dynamic/base';
import { catchError, map, Observable, of, shareReplay } from 'rxjs';
import {
  SOFTLINE_CONFIG_WWS_ARTIKELSTAMM,
  SOFTLINE_PERMISSION_ARTIKELSTAMM,
} from './artikelstamm.shared';
import { ArtikelstammSearchResultComponent } from './search/artikelstamm-search-result.component';
import { WwsArtikelstammConfiguration } from './types/artikelstamm-configuration';

// Module-level providers WITHOUT the menu/i18n registration and without the
// routes graph — composed at boot by both provideWwsArtikelstamm (monolith
// path) and the remote's ./ModuleGlobals entry (federation path).
// Must not import the routes file.
export function provideWwsArtikelstammGlobals(
  config?: WwsArtikelstammConfiguration
): Array<Provider | EnvironmentProviders> {
  return [
    {
      provide: SOFTLINE_CONFIG_WWS_ARTIKELSTAMM,
      useValue: config,
    },
    provideSearchModule<any>({
      url: '/artikelstamm',
      category: 'Artikelstamm',
      icon: 'fa-regular fa-database',
      permission: SOFTLINE_PERMISSION_ARTIKELSTAMM,
      component: ArtikelstammSearchResultComponent,
      factory: () => {
        const fieldOkService = new FieldOkService(inject(ConnectionHttpService), 'artstamm');

        let lastTerm = '';
        let lastResult$: Observable<any[]> = of([]);

        return {
          results(term: string | null): Observable<any[]> {
            const normalized = term?.trim() ?? '';
            if (normalized.length < 3) return of([]);
            if (normalized === lastTerm) return lastResult$;

            lastTerm = normalized;
            lastResult$ = fieldOkService.query({ filter: normalized, multiValued: false, parameters: {} as any, maxAbfrageResults: 20 }).pipe(
              map((response: any) => {
                if (Array.isArray(response)) return response.slice(0, 20);
                if (response?.data) return Object.values(response.data).slice(0, 20);
                return [];
              }),
              catchError(() => of([])),
              shareReplay(1)
            );
            return lastResult$;
          },
        };
      },
    }),
  ];
}
